<template>
  <v-main style="height: 100%">
    <v-overlay :value="loading">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="mt-4 font-weight-medium white--text">
          {{ languageSelect === 0 ? '⚙️ กำลังดำเนินการ กรุณารอสักครู่...' : '⚙️ Processing, please wait...' }}
        </div>
      </div>
    </v-overlay>

    <!-- Header Banner -->
    <v-card
      flat
      tile
      class="martech-header d-flex align-center justify-center"
      height="200px"
      width="100%"
    >
      <div class="header-overlay d-flex flex-column align-center justify-center" style="width:100%">
        <div class="header-badge px-6 py-2 mb-1">
          <span class="header-logo-text">MARTECH</span>
          <span class="header-logo-year ml-2">2026</span>
        </div>
        <div class="header-sub white--text text-caption">
          {{ languageSelect === 0 ? 'งานมหกรรมการตลาดดิจิทัล' : 'Digital Marketing Festival' }}
        </div>
      </div>
    </v-card>

    <!-- Main Card -->
    <v-card
      class="pa-3 pb-10 mt-n8"
      color="white"
      style="min-height: 100vh; border-radius: 32px 32px 0 0;"
      elevation="0"
    >
      <!-- LINE Avatar (ดึงมาจาก v-avatar ลอยขึ้น) -->
      <v-row justify="center" class="mt-n10 mb-3">
        <v-col cols="auto">
          <v-avatar size="90" color="white" class="elevation-6" style="border: 3px solid white;">
            <v-img
              v-if="profile.pictureUrl"
              :src="profile.pictureUrl"
              :alt="profile.displayName"
            ></v-img>
            <v-icon v-else size="52" color="indigo darken-2">mdi-account-circle</v-icon>
          </v-avatar>
        </v-col>
      </v-row>

      <!-- Language Toggle -->
      <div style="display:flex; justify-content:center;" class="mb-3">
        <v-chip
          class="mr-1 font-weight-bold"
          :color="languageSelect === 0 ? 'indigo darken-2' : 'grey lighten-3'"
          :text-color="languageSelect === 0 ? 'white' : 'grey darken-1'"
          @click="languageSelect = 0"
        >
          <v-avatar left>
            <v-img src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e"></v-img>
          </v-avatar>
          TH
        </v-chip>
        <v-chip
          class="ml-1 font-weight-bold"
          :color="languageSelect === 1 ? 'indigo darken-2' : 'grey lighten-3'"
          :text-color="languageSelect === 1 ? 'white' : 'grey darken-1'"
          @click="languageSelect = 1"
        >
          <v-avatar left>
            <v-img src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b"></v-img>
          </v-avatar>
          EN
        </v-chip>
      </div>

      <!-- Greeting Card -->
      <v-card
        class="mx-2 mb-4 pa-4"
        color="indigo lighten-5"
        elevation="0"
        style="border-radius: 16px; border: 1.5px solid #c5cae9;"
      >
        <div class="d-flex align-center" style="gap: 12px;">
          <div>
            <div class="text-caption grey--text text--darken-1 mb-1">
              {{ languageSelect === 0 ? '👋 สวัสดี!' : '👋 Hello!' }}
            </div>
            <div class="font-weight-bold indigo--text text--darken-2" style="font-size:18px; line-height:1.3;">
              {{ profile.displayName || (languageSelect === 0 ? 'ผู้เข้าร่วมงาน' : 'Attendee') }}
            </div>
            <div
              v-if="profile.statusMessage"
              class="text-caption grey--text text--darken-1 mt-1"
              style="font-style: italic;"
            >
              "{{ profile.statusMessage }}"
            </div>
          </div>
        </div>
        <v-divider class="my-3"></v-divider>
        <div class="text-body-2 grey--text text--darken-2">
          {{ languageSelect === 0
            ? 'กรุณาเลือกบูธที่คุณสนใจเพื่อลงทะเบียนเข้าร่วมกิจกรรม'
            : 'Please select a booth you are interested in to register for the event.'
          }}
        </div>
      </v-card>

      <!-- Form: เลือกบูธ only -->
      <v-form ref="form" v-model="valid" lazy-validation class="px-2">

        <!-- Booth Select -->
        <v-select
          v-model="form.booth"
          :items="branchData"
          item-text="text"
          item-value="value"
          :label="languageSelect === 0 ? 'เลือกบูธ *' : 'Select Booth *'"
          outlined
          color="indigo darken-2"
          background-color="grey lighten-5"
          :rules="[rules.required]"
          attach
          :menu-props="{ bottom: true, offsetY: true }"
          prepend-inner-icon="mdi-store-outline"
        >
          <template slot="item" slot-scope="data">
            <p class="text-wrap my-1">{{ languageSelect === 0 ? data.item.text : data.item.textEn }}</p>
          </template>
        </v-select>

        <!-- Submit Button -->
        <v-col cols="12" class="text-center pa-0 mt-2">
          <v-btn
            id="btn-submit-register"
            block
            dark
            x-large
            color="indigo darken-2"
            style="border-radius: 14px;"
            :loading="submitting"
            @click="handleSubmit"
          >
            <v-icon left>mdi-check-circle-outline</v-icon>
            {{ languageSelect === 0 ? 'ยืนยันลงทะเบียน' : 'Confirm Registration' }}
          </v-btn>
        </v-col>

      </v-form>

      <!-- Footer -->
      <p class="text-center grey--text text--lighten-1 mt-6" style="font-size:11px;">
        Powered by <strong>BeTask</strong>
      </p>
    </v-card>

    <!-- Success Dialog -->
    <v-dialog v-model="dialogSuccess" max-width="320" persistent>
      <v-card class="text-center pa-4">
        <v-icon size="60" color="success" class="mb-2">mdi-check-circle</v-icon>
        <v-card-title class="justify-center font-weight-bold">
          {{ languageSelect === 0 ? 'ลงทะเบียนสำเร็จ!' : 'Registered Successfully!' }}
        </v-card-title>
        <v-card-text class="grey--text">
          {{ languageSelect === 0
            ? `ขอบคุณ ${profile.displayName || ''} ที่ลงทะเบียนเข้าร่วมงาน`
            : `Thank you ${profile.displayName || ''} for registering.`
          }}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="indigo darken-2" dark rounded @click="dialogSuccess = false">
            {{ languageSelect === 0 ? 'ตกลง' : 'OK' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-main>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'Martech2026Register',
  data () {
    return {
      branchData: [],
      valid: true,
      loading: false,
      submitting: false,
      languageSelect: 0,
      dialogSuccess: false,
      shopId: '',
      form: {
        booth: null
      },
      rules: {
        required: v => !!v || (this.languageSelect === 0 ? 'กรุณากรอกข้อมูล' : 'This field is required')
      }
    }
  },
  async mounted () {
    this.loading = true
    if (
      this.$route.query.error === 'ACCESS_DENIED' ||
      this.$route.query.error === 'access_denied'
    ) {
      const queryString = decodeURIComponent(window.location.search).replace(
        '?liff.state=',
        ''
      )
      // console.log('queryString', queryString)
      const params = new URLSearchParams(queryString)
      this.shopId = params.get('shopId')
    } else {
      this.shopId = this.$route.query.shopId
      let checkShopId = ''
      if (this.$route.query.shopId) {
        checkShopId = this.$route.query.shopId
      } else {
        const queryString = decodeURIComponent(window.location.search).replace(
          '?liff.state=',
          ''
        )
        // console.log('queryString', queryString)
        const params = new URLSearchParams(queryString)
        checkShopId = params.get('shopId')
      }
      let dataLineConfig = await this.getDataLineConfig(checkShopId)
      await this.checkLiffLogin(dataLineConfig)
    }
    await this.getDataBranch()
    this.loading = false
  },
  methods: {
    async getDataBranch () {
      this.branchData = []
      await axios
        .get(this.DNS_IP + '/master_branch/get?shopId=' + this.shopId)
        .then(async response => {
          let rs = response.data
          console.log('rs', rs)
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              d.text = d.masBranchName
              d.textEng = d.masBranchNameEn
              d.value = d.masBranchID
              this.branchData.push(d)
            }
          }
          console.log('this.branchData', this.branchData)
        }).catch(err => {
          console.log('err', err)
        })
    },
    async checkLiffLogin (dataLineConfig) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href })
            } else {
              await this.getProfile()
              // await this.liffSendMessages()
            }
          }
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    },
    async getDataChkMember () {
      if (this.profile.userId) {
        axios
          .get(
            this.DNS_IP +
              '/member/get?shopId=' +
              this.shopId +
              '&liffUserId=' +
              this.profile.userId
          )
          .then(async result => {
            // if (typeof result.data.status === 'undefined') {
            //   lineUserIds = result.data[0].lineUserId || ''
            //   liffUserIds = result.data[0].liffUserId || ''
            // }
            if (result.data.status === false) {
              this.onSubmit()
            } else {
              this.onUpdate(result.data[0].memberId)
            }
          }).catch(err => {
            console.log('err', err)
            this.$swal({
              title: 'ผิดพลาด',
              text: 'กรุณาลองใหม่อีกครั้ง',
              type: 'info',
              // timer: 5000,
              showConfirmButton: true
            })
          })
      } else {
        this.$swal({
          title: 'ผิดพลาด',
          text: 'กรุณาลองใหม่อีกครั้ง',
          type: 'info',
          // timer: 5000,
          showConfirmButton: true
        })
      }
    },
    async onSubmit () {
      // var idMember = 'Link_' + Date.now()
      var idMember = moment().valueOf()
      const params = {
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        liffUserId: this.profile.userId,
        lineUserId: this.profile.userId,
        shopId: this.$route.query.shopId,
        memberId: idMember,
        boothEmpBranch: this.form.booth,
        boothEmpStatus: 'True',
        CREATE_USER: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity(
        'post',
        `/member/add`,
        params
      )
      this.$refs.form.reset()
      console.log('result', result.status)
    },
    async onUpdate (idMember) {
      console.log('this.form.booth', this.form.booth)
      // "https://api-belinked.betaskthai.com/member/editWebhook/" + request.body.events[0].message.text.split(" ")[2]
      // window.location.replace(`https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`)
      // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`
      const params = {
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        shopId: this.$route.query.shopId,
        boothEmpBranch: this.form.booth,
        boothEmpStatus: 'True',
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity(
        'post',
        '/member/edit/' + idMember,
        params
      )
      this.$refs.form.reset()
      console.log('result', result.status)
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      //   const token = this.$liff.getAccessToken() || '1234567890'
      await axios({
        method: method,
        // headers: {
        //   accessToken: token,
        //   lineUserId: this.profile.userId,
        //   activityId: this.formUpdate.activityId
        // },
        url: this.DNS_IP + url,
        data: params
      })
        .then(response => {
          result = response.data
        })
        .catch(error => {
          console.log(error)
          result = null
        })
      return result
    },
    async handleSubmit () {
      if (!this.$refs.form.validate()) return
      this.submitting = true
      await this.getDataChkMember()
      this.submitting = false
      this.dialogSuccess = true
    }
  }
}
</script>

<style scoped>
.martech-header {
  background: linear-gradient(135deg, #1a237e 0%, #283593 40%, #3949ab 100%);
  position: relative;
  overflow: hidden;
}

.martech-header::before {
  content: '';
  position: absolute;
  top: -60px;
  right: -60px;
  width: 220px;
  height: 220px;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 50%;
}

.martech-header::after {
  content: '';
  position: absolute;
  bottom: -40px;
  left: -40px;
  width: 160px;
  height: 160px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
}

.header-overlay {
  position: relative;
  z-index: 1;
}

.header-badge {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 50px;
  display: inline-flex;
  align-items: baseline;
}

.header-logo-text {
  font-size: 28px;
  font-weight: 800;
  color: white;
  letter-spacing: 5px;
}

.header-logo-year {
  font-size: 20px;
  font-weight: 700;
  color: #90caf9;
}

.header-sub {
  letter-spacing: 1.5px;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/Martech2026/register.vue